import React from "react";
import { CardElement, useStripe, useElements } from "@stripe/react-stripe-js";

const CARD_ELEMENT_OPTIONS = {
  style: {
    base: {
      fontSize: "16px",
      color: "#32325d",
      "::placeholder": {
        color: "#a0aec0",
      },
    },
    invalid: {
      color: "#e53e3e",
    },
  },
};

const CheckoutFormCardElement = ({ clientSecret }) => {
  const stripe = useStripe();
  const elements = useElements();

  const handleSubmit = async (event) => {
    event.preventDefault();

    if (!stripe || !elements) return;

    const { error, paymentIntent } = await stripe.confirmCardPayment(
      clientSecret,
      {
        payment_method: {
          card: elements.getElement(CardElement),
          billing_details: {
            name: "Customer Name", // dynamically from form input ideally
            address: {
              country: "IN",
            },
          },
        },
      }
    );

    if (error) {
      console.error("Payment failed:", error.message);
    } else if (paymentIntent.status === "succeeded") {
      alert("Payment successful!");
    }
  };

  return (
    <form onSubmit={handleSubmit} style={{ maxWidth: 400, margin: "auto" }}>
      <label>Card details</label>
      <div
        style={{ border: "1px solid #000", padding: "12px", borderRadius: 6 }}
      >
        <CardElement options={CARD_ELEMENT_OPTIONS} />
      </div>

      {/* Country hidden but set to IN in billing_details */}
      <input type="hidden" name="country" value="IN" />

      <button
        type="submit"
        disabled={!stripe}
        style={{
          background: "#5469d4",
          color: "#fff",
          padding: "10px 16px",
          border: "none",
          borderRadius: 4,
          marginTop: 16,
          width: "100%",
        }}
      >
        Pay
      </button>
    </form>
  );
};

export default CheckoutFormCardElement;
